import React, { useState, useEffect, useRef, useCallback } from 'react'
import { Box, Text, DropButton, CheckBox, TextInput, Select } from "grommet"
import { Revert, Download, Splits } from "grommet-icons"

import { AgGridReact } from 'ag-grid-react'
import AgDataTableActionsDropDown from './AgDataTableActions'

import { themeBalham } from 'ag-grid-community';
import AppDataTableDetail from './AppDataTableDetail'

import { useNavigate } from "react-router-dom"
import { CSVLink } from "react-csv"
import { CircularButton } from "./CircularButton"

import envConfig from '../../utils/envConfig'
const csvExportParams = { suppressQuotes: true }


export const ColumnFilter = ({ agTable }) => {

    const [showList, setShowList] = useState(false)
    const [dropContent, setDropContent] = useState([])

    const handleClickDropButton = () => {
        setShowList(!showList)
    }

    useEffect(() => {
        if (showList === true && agTable.current instanceof AgGridReact) {
            setDropContent(agTable.current.api.getColumnState())
        }
    }, [showList, agTable])

    const DropContent = ({ label_array }) => (
        <Box background="light-2" overflow="auto" >
            {label_array && label_array.map(label => {
                return (
                    <DropLink key={label.colId} content={label.colId} checked={!label.hide} />
                )
            })}
            <Box background="light-2">
                <Box
                    pad="small"
                    onClick={() => {
                        setDropContent(agTable.current.api.getColumnState())
                    }}
                >
                    <Text alignSelf="center" size="15px"><Revert size="15px" /> Revert to Default</Text>
                </Box>
            </Box>
        </Box>
    )

    const DropLink = ({ content, checked }) => {

        const [ischecked, setIsChecked] = useState(checked);

        return (

            <Box background="light-2">
                <CheckBox
                    onChange={(event) => {
                        setIsChecked(event.target.checked)
                        agTable.current.api.setColumnsVisible([content], !ischecked)
                        setDropContent(agTable.current.api.getColumnState())
                    }}
                    checked={ischecked}
                    label={<Text margin="small" color="brand" size="15px">{agTable.current.api.getColumn(content).colDef.headerName}</Text>}
                    hoverIndicator={{ color: "brand", opacity: "weak" }}
                />
            </Box>
        )
    }

    return (
        <DropButton
            name="DropDown"
            open={showList}
            onOpen={() => handleClickDropButton()}
            onClose={() => handleClickDropButton()}
            dropContent={<DropContent label_array={dropContent} onClose={() => handleClickDropButton()} />}
            hoverIndicator={{ color: "light-1", opacity: "weak" }}
            dropProps={{ align: { top: "bottom", right: "right" } }}
            dropAlign={{ top: 'bottom', right: 'right' }}
        >
            <CircularButton icon={<Splits color="light-3" />} />

        </DropButton>
    )
}

const AgDataTable = ({
    tab_col, tab_data, link_to = false, defaultSubTab = '',
    tableDefaultFilter, rowHeight = 30, tableName, disableButtons = false,
    setFetchID = false, handleClickService = false,
    selection = "single", nodeName = "", handleClick = false, showDetailedButton = true,
    tableHeight = 1500, paginationPageSize = 50, onCellValueChanged = false, title = "",
    justSearch = false, backgroundColor = "light-1", getRowStyle = null
}) => {

    const [downloadData, setDownloadData] = useState([])
    const [detailView, setDetailView] = useState({})
    const [enableDetailView, setEnableDetailView] = useState(selection === "single")
    const liteMode = envConfig[process.env.REACT_APP_ENVIRONMENT]['lite']

    const csvFileName = 'DownloadData.csv'

    // Table State Code
    const [triageActionReason, setTriageActionReason] = useState("")

    // For AWS S3 Table only
    const [s3PolicyExpire, setS3PolicyExpire] = useState(20)
    const [s3ResyncHours, setS3ResyncHours] = useState(12)

    let history = useNavigate()
    let agTable = useRef({})

    useEffect(() => {
        setDetailView({})
    }, [tableDefaultFilter])

    // Fix a crash message
    setTimeout(function () { if (agTable.current instanceof AgGridReact && agTable.current.api && agTable.current.api.setGridOption) { agTable.current.api.setGridOption('rowData', tab_data) } }, 0)

    // Search
    const [searchValue, setSearchValue] = useState('');
    const handleSearch = (value) => {
        setSearchValue(value)
        if (agTable.current instanceof AgGridReact && agTable.current.api && agTable.current.api.setGridOption) {
            agTable.current.api.setGridOption('quickFilterText', value);
        }
    }
    const getRowId = params => params.data.uniqueId;

    const autoSizeAll = useCallback((skipHeader) => {
        const allColumnIds = [];
        agTable && agTable.current && agTable.current.api && agTable.current.api.getColumns().forEach((column) => {
            allColumnIds.push(column.getId());
        });
        agTable && agTable.current && agTable.current.api && agTable.current.api.autoSizeColumns(allColumnIds, skipHeader);
    }, [agTable]);

    return (
        <Box fill background={backgroundColor} name="data_table" pad="none">

            <Box
                fill="horizontal"
                overflow="auto"
                align="start" alignContent="start" justify="start" gap="medium" margin="none"
                background={backgroundColor}
                pad="xsmall" direction="column"
            >
                {(justSearch || !disableButtons) &&
                <Box fill="horizontal" gap="small" pad={{ bottom: "small" }}>
                    {justSearch &&
                        <Box width="200px">
                            <TextInput
                                size="xsmall"
                                placeholder="search datatable"
                                value={searchValue}
                                onChange={event => handleSearch(event.target.value)}
                            />

                        </Box>
                    }

                    {!disableButtons &&
                        <Box fill="horizontal" gap="none">
                            <Box fill="horizontal" flex={false} margin="xsmall" direction="row">
                                <Box basis="98%" direction='row' justify='start' gap="small">
                                    {title && <Text pad="medium" margin={{ left: "5px" }} size="medium" color="brand" weight="bold">{title}</Text>}

                                    <Box width="300px">
                                        <TextInput
                                            size="xsmall"
                                            placeholder="search datatable"
                                            value={searchValue}
                                            onChange={event => handleSearch(event.target.value)}
                                        />
                                    </Box>

                                </Box>

                                <Box basis={selection !== "single" ? "1" : "auto"} align="center" alignContent="center" alignSelf="center" direction='row' margin={{ right: "10px" }}>
                                    <ColumnFilter agTable={agTable} />

                                    {!liteMode &&
                                        <CSVLink data={downloadData} filename={csvFileName} onClick={() => {
                                            if (agTable && agTable.current instanceof AgGridReact) {
                                                setDownloadData(agTable.current.api.getDataAsCsv(csvExportParams))
                                                return true;
                                            }
                                            return false;

                                        }}>
                                            <CircularButton text="Download" icon={<Download color="light-3" />} />
                                        </CSVLink>
                                    }

                                    {selection !== "single" && tableName === "AWSS3" &&
                                        <Box width="190px" margin={{ left: "5px", right: "5px" }}>
                                            <Text weight="bold" size="10px">Deny Expiry (Minutes)</Text>
                                            <Select
                                                options={[20, 30, 40, 60, 90]}
                                                value={s3PolicyExpire}
                                                onChange={({ option }) => setS3PolicyExpire(option)}
                                            />
                                        </Box>
                                    }

                                    {selection !== "single" && tableName === "AWSS3" &&
                                        <Box width="160px" margin={{ left: "5px", right: "5px" }}>
                                            <Text weight="bold" size="10px">Resync (Hours)</Text>
                                            <Select
                                                options={[12, 18, 24, 48, 72]}
                                                value={s3ResyncHours}
                                                onChange={({ option }) => setS3ResyncHours(option)}
                                            />
                                        </Box>
                                    }

                                    {selection !== "single" && tableName !== "SmoketestDowntimeDetails" &&
                                        <Box width="210px" margin={{ left: "5px", right: "5px" }}>
                                            <Text weight="bold" size="10px">Triage Action Reason</Text>
                                            <TextInput
                                                size="xsmall"
                                                placeholder="Reason"
                                                value={triageActionReason}
                                                onChange={event => setTriageActionReason(event.target.value)}
                                            />
                                        </Box>
                                    }

                                    {selection !== "single" &&
                                        <AgDataTableActionsDropDown agTable={agTable}
                                            nodeName={nodeName}
                                            tableName={tableName} enableDetailView={enableDetailView}
                                            setEnableDetailView={setEnableDetailView}
                                            showDetailedButton={showDetailedButton}
                                            triageActionReason={triageActionReason}
                                            s3PolicyExpiration={s3PolicyExpire}
                                            s3ResyncHours={s3ResyncHours}
                                        />
                                    }
                                </Box>

                            </Box>
                        </Box>
                    }

                </Box>
                }

                <Box
                    height={tableHeight + "px"}
                    width="100%"
                    margin={{ top: "0px" }}
                >

                    <AgGridReact
                        theme={themeBalham}
                        ref={agTable}
                        //animateRows={true}
                        suppressRowHoverHighlight={true} //disable row highlight
                        getRowStyle={getRowStyle}
                        rowHeight={rowHeight}
                        rowSelection={selection}
                        enableCellTextSelection={true}
                        pagination={true}
                        paginationPageSize={paginationPageSize}
                        onCellValueChanged={onCellValueChanged}
                        onRowClicked={e => {
                            if (enableDetailView) {
                                if (link_to) {
                                    history(link_to + (e.node.data.id) + history.location.search)
                                }
                                if (setFetchID !== false) {
                                    setFetchID(e.node.data.id)
                                }
                                if (e.node.data.detailView) {
                                    setDetailView({})
                                    setDetailView(e.node.data.detailView)
                                }
                                if (handleClickService) {
                                    handleClickService(e.node.data.service, e.node.data.instance)
                                }
                                if (handleClick) {
                                    handleClick(e.node.data)
                                }
                            }
                        }}
                        defaultColDef={
                            {
                                sortable: true,
                                filter: true,
                                resizable: true,
                                cellStyle: { 'fontSize': '12px', 'fontFamily': "'Metrophobic', sans-serif" },
                                floatingFilter: false,
                            }
                        }
                        columnDefs={tab_col}
                        getRowId={getRowId}
                        onFirstDataRendered={e => autoSizeAll(false)}
                        onGridReady={
                            e => {
                                e.api.setFilterModel(tableDefaultFilter)
                                setDownloadData(e.api.getDataAsCsv(csvExportParams))
                                window.onresize = () => {
                                    autoSizeAll(false)
                                }
                            }
                        }
                    />
                </Box>
            </Box>

            {Object.keys(detailView).length > 0 &&
                <AppDataTableDetail
                    detailView={detailView}
                    defaultSubTab={defaultSubTab}
                />
            }
        </Box>

    )
}

export default AgDataTable
